import { post, get } from '../axios'

// 分页查询列表
export function abtest_list_post(map, option) {
  return post(`${process.env.VUE_APP_ABTEST}/abtest/list`, map, option).then(
    response => response
  )
}

// 修改状态
export function abtest_modifystatus_post(map, option) {
  return post(
    `${process.env.VUE_APP_ABTEST}/abtest/modifystatus`,
    map,
    option
  ).then(response => response)
}

// 根据id查询详情
export function abtest_query_get(map, option) {
  return get(`${process.env.VUE_APP_ABTEST}/abtest/query`, map, option).then(
    response => response
  )
}

// 保存
export function abtest_save_post(map, option) {
  return post(`${process.env.VUE_APP_ABTEST}/abtest/save`, map, option).then(
    response => response
  )
}

// 查询操作日志
export function abtest_queryLog_get(map, option) {
  return get(`${process.env.VUE_APP_ABTEST}/abtest/queryLog`, map, option).then(
    response => response
  )
}

// 删除
export function abtest_remove_get(map, option) {
  return get(`${process.env.VUE_APP_ABTEST}/abtest/remove`, map, option).then(
    response => response
  )
}

// 查询实验报告基本数据
export function abtest_getAbReportBaseInfo_get(map, option) {
  return get(
    `${process.env.VUE_APP_ABTEST}/abtest/getAbReportBaseInfo`,
    map,
    option
  ).then(response => response)
}

// 查询实验报告报表数据
export function abtest_getAbReportInfo_post(map, option) {
  return post(
    `${process.env.VUE_APP_ABTEST}/abtest/getAbReportInfo`,
    map,
    option
  ).then(response => response)
}

// 查询AB测试指标选项
export function abtest_listAbtestMetricOption_get(map, option) {
  return get(
    `${process.env.VUE_APP_ABTEST}/abtest/listAbtestMetricOption`,
    map,
    option
  ).then(response => response)
}

// 查询实验模块选项
export function abtest_listAbtestModule_get(map, option) {
  return get(
    `${process.env.VUE_APP_ABTEST}/abtest/listAbtestModule`,
    map,
    option
  ).then(response => response)
}
